import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
import { Can } from '../../../_contexts/AbilitiesContext'

export default function MessagesEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          You don't have any messages.
        </h5>

        <Can I="send" a="messages">
          <div className='my-4'>
            Send a message by clicking "Send Message"
          </div>
          <Button as={Link} to='/messages/send' variant='outline-primary' className="px-5">
            Send Message
          </Button>
        </Can>

      </Card.Body>
    </Card>
  )
}
